export default {
  "nav.home": "首页",
  "nav.categories": "服务分类",
  "nav.articles": "体育资讯",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "hero.title": "让运动改变生活",
  "hero.subtitle": "专业、高效、全面的体育运动解决方案",
  "hero.cta": "了解更多",
  "hero.cta2": "立即咨询",
  "services.title": "核心服务",
  "services.subtitle": "为您提供一站式体育运动解决方案",
  "stats.title": "平台数据",
  "stats.coaches": "专业教练",
  "stats.events": "承办赛事",
  "stats.users": "服务用户",
  "stats.venues": "合作场馆",
  "categories.title": "服务分类",
  "categories.subtitle": "按需选择最适合您的体育服务",
  "categories.training": "体育培训",
  "categories.events": "赛事组织",
  "categories.equipment": "运动装备",
  "categories.venues": "场馆管理",
  "articles.title": "体育资讯",
  "articles.subtitle": "最新体育动态与专业解读",
  "articles.readMore": "阅读全文",
  "articles.backToList": "返回列表",
  "articles.category": "分类",
  "articles.publishDate": "发布时间",
  "cta.title": "准备好开启您的运动之旅了吗？",
  "cta.subtitle": "立即联系我们，获取专属体育运动解决方案",
  "cta.button": "免费咨询",
  "about.brand.title": "品牌介绍",
  "about.brand.subtitle": "关于云开体育",
  "about.reputation.title": "荣誉资质",
  "about.reputation.subtitle": "行业认可与专业认证",
  "about.contact.title": "联系我们",
  "about.contact.subtitle": "期待与您的沟通",
  "footer.copyright": "© 2026 云开体育 版权所有",
  "footer.about": "关于我们",
  "footer.services": "服务项目",
  "footer.contact": "联系方式",
  "footer.articles": "体育资讯",
  "breadcrumb.home": "首页",
  "category.all": "全部",
  "category.training": "体育培训",
  "category.events": "赛事组织",
  "category.equipment": "运动装备",
  "category.venues": "场馆管理",
}